export const VIEW_GET_OTP = 'VIEW_GET_OTP';
export const VIEW_GET_OTP_SUCCESS = 'VIEW_GET_OTP_SUCCESS';
export const VIEW_GET_OTP_ERROR = 'VIEW_GET_OTP_ERROR';

export const VIEW_APPOINTMENTS = 'VIEW_APPOINTMENTS';
export const VIEW_APPOINTMENTS_SUCCESS = 'VIEW_APPOINTMENTS_SUCCESS';
export const VIEW_APPOINTMENTS_ERROR = 'VIEW_APPOINTMENTS_ERROR';

export const VERIFY_MODIFY_BOOKING = 'VERIFY_MODIFY_BOOKING';
export const VERIFY_MODIFY_BOOKING_SUCCESS = 'VERIFY_MODIFY_BOOKING_SUCCESS';
export const VERIFY_MODIFY_BOOKING_ERROR = 'VERIFY_MODIFY_BOOKING_ERROR';

export const CANCEL_BOOKING = 'CANCEL_BOOKING';
export const CANCEL_BOOKING_SUCCESS = 'CANCEL_BOOKING_SUCCESS';
export const CANCEL_BOOKING_ERROR = 'CANCEL_BOOKING_ERROR';

export const RESCHEDULE_BOOKING = 'RESCHEDULE_BOOKING';
export const RESCHEDULE_BOOKING_SUCCESS = 'RESCHEDULE_BOOKING_SUCCESS';
export const RESCHEDULE_BOOKING_ERROR = 'RESCHEDULE_BOOKING_ERROR';
